module.exports = __webpack_public_path__ + "img/admin-logo.bd37e3d9.png";